import Column from "@amzn/meridian/esm/components/column";
import Loader from "@amzn/meridian/esm/components/loader";
import Text from "@amzn/meridian/esm/components/text";

/**
 * RtmsLoading - Loading view shown while RTMS is starting or stopping.
 */
const RtmsLoading = () => {
  return (
    <Column alignmentHorizontal="center" alignmentVertical="center" height="300px">
      <Loader />
      <Text type="h50" color="primary">Starting Amazon Meetings Assistant...</Text>
    </Column>
  );
};

export default RtmsLoading;
